var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeatureTileIcon02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    d: "M21 23h22v18H21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 28h12M26 32h12M26 36h5",
    stroke: "#ACADFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureTileIcon02);
export default __webpack_public_path__ + "static/media/feature-tile-icon-02.469356592c7ce3b1abf53cca85e82fee.svg";
export { ForwardRef as ReactComponent };